<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="bullseye"/>
          {{$t('title')}}
        </h1>
      </div>
    </div>
    <k-p-i-setup></k-p-i-setup>
  </main>
</template>

<script>
import KPISetup from "@/views/commission/KPISetup";
export default {
  components: {KPISetup},
  data() {
    return {
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'KPI Setup',
      },
      vi: {
        title: 'Cài đặt KPI',
      }
    }
  },
}
</script>